import styled from 'styled-components';
import { AZ } from '../../layouts/AppLayout.styled';

export const StubWrap = styled.div`
  display: grid;
  place-items: center;
  text-align: center;
  gap: 8px;
  min-height: 360px;
  background: #fff;
  border: 1px dashed #d9d9d9;
  border-radius: 12px;
  padding: 48px 24px;

  .stub-icon {
    width: 56px;
    height: 56px;
    border-radius: 14px;
    display: grid;
    place-items: center;
    background: ${AZ.pageBg};
    color: ${AZ.soft};
    font-size: 22px;
  }
  .stub-title {
    font-size: 16px;
    font-weight: 700;
    color: ${AZ.ink};
  }
  .stub-sub {
    font-size: 13px;
    color: ${AZ.soft};
    max-width: 360px;
  }
`;
